export const tdaPortalId = "tda-portal";
